import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    id: "site-footer",
    class: "bg-black text-white",
    "data-site-footer": ""
};
const _hoisted_2 = { class: "container grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-y-10" };
const _hoisted_3 = { class: "footer-col order-first col-span-full flex justify-center !py-10 lg:mb-10 lg:!py-20" };
const _hoisted_4 = { class: "footer-col lg:!b-0 lg:order-7 lg:border-none" };
const _hoisted_5 = { class: "footer-col lg:order-2" };
const _hoisted_6 = { class: "footer-col lg:order-5 lg:border-none lg:!pb-0" };
const _hoisted_7 = ["href"];
const _hoisted_8 = {
    key: 1,
    class: "!font-jp text-xs font-bold"
};
const _hoisted_9 = { class: "footer-col lg:order-3" };
const _hoisted_10 = { class: "text-xs" };
const _hoisted_11 = { class: "text-xs" };
const _hoisted_12 = { class: "footer-col lg:order-6 lg:border-none lg:!pb-0" };
const _hoisted_13 = { class: "footer-col lg:order-4" };
const _hoisted_14 = { class: "footer-col col-span-full lg:order-8 lg:border-t lg:pt-10" };
const _hoisted_15 = { class: "footer-col col-span-full lg:order-9 lg:grid lg:grid-cols-3 lg:gap-5 lg:border-none lg:!pb-0" };
const _hoisted_16 = { class: "mb-5 text-xs" };
import { defineAsyncComponent, computed } from 'vue';
import { MqResponsive } from 'vue3-mq';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SiteFooter',
    props: {
        footerNavigation: {
            type: Object,
            required: true,
        },
        policiesNavigation: {
            type: Object,
            required: true,
        },
        ourOtherSites: {
            type: Object,
            required: true,
        },
        copyrightInformation: {
            type: String,
            required: true,
        },
        hideNewsletterForm: {
            type: Boolean,
            required: false,
            default: false,
        },
        newsletterSignUp: {
            type: Object,
            required: true,
        },
        address: {
            type: String,
            required: true,
        },
        japaneseText: {
            type: String,
            required: true,
        },
        japaneseLink: {
            type: Object,
            required: true,
        },
        contactPage: {
            type: Object,
            required: true,
        },
        visitPage: {
            type: Object,
            required: true,
        },
        socialLinks: {
            type: Object,
            required: true,
        },
        openingHours: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const SiteLogo = defineAsyncComponent(() => import('@atoms/SiteLogo.vue'));
        const SocialLinks = defineAsyncComponent(() => import('@molecules/SocialLinks.vue'));
        const FooterNavigation = defineAsyncComponent(() => import('@molecules/FooterNavigation.vue'));
        const AccordionToggle = defineAsyncComponent(() => import('@atoms/AccordionToggle.vue'));
        const OtherSitesNavigation = defineAsyncComponent(() => import('@molecules/OtherSitesNavigation.vue'));
        const PoliciesNavigation = defineAsyncComponent(() => import('@molecules/PoliciesNavigation.vue'));
        const NewsletterCta = defineAsyncComponent(() => import('@organisms/NewsletterCta.vue'));
        const ButtonWithArrow = defineAsyncComponent(() => import('@atoms/ButtonWithArrow.vue'));
        const props = __props;
        const formattedOpeningHours = computed(() => {
            if (!props.openingHours)
                return '';
            // Split the string by <br /> and wrap each part with <p> tags
            const parts = props.openingHours.split('<br />');
            return parts
                .map((part) => `<p class="text-xs lg:mb-0">${part}</p>`)
                .join('\n');
        });
        //Google maps link creation
        const getDirectionsLink = computed(() => {
            if (!props.address)
                return null;
            const cleanAddress = props.address
                .replace(/["'“”‘’]/g, '')
                .replace(/<br \/>/g, ' ')
                .replace('\r\n', '')
                .replace(/ /g, '+');
            return `https://www.google.com/maps/dir/?api=1&origin=current+location&destination=${cleanAddress}&travelmode=driving`;
        });
        return (_ctx, _cache) => {
            const _directive_dompurify_html = _resolveDirective("dompurify-html");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!__props.hideNewsletterForm)
                    ? (_openBlock(), _createBlock(_unref(NewsletterCta), {
                        key: 0,
                        newsletterSignUp: __props.newsletterSignUp
                    }, null, 8, ["newsletterSignUp"]))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(SiteLogo), {
                                navOpen: true,
                                sizeXL: true
                            })
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(SocialLinks), { "social-links": __props.socialLinks }, null, 8, ["social-links"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(FooterNavigation), { navigation: __props.footerNavigation }, null, 8, ["navigation"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (__props.japaneseLink)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "!font-jp text-xs font-bold",
                                    href: __props.japaneseLink.url
                                }, _toDisplayString(__props.japaneseText), 9, _hoisted_7))
                                : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.japaneseText), 1))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_unref(MqResponsive), { group: "" }, {
                                "md-": _withCtx(() => [
                                    _createVNode(_unref(AccordionToggle), { title: "Address" }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("p", _hoisted_10, null, 512), [
                                                [_directive_dompurify_html, __props.address]
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                "lg+": _withCtx(() => [
                                    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-xs font-bold" }, "Address", -1)),
                                    _withDirectives(_createElementVNode("p", _hoisted_11, null, 512), [
                                        [_directive_dompurify_html, __props.address]
                                    ]),
                                    (getDirectionsLink.value)
                                        ? (_openBlock(), _createBlock(_unref(ButtonWithArrow), {
                                            key: 0,
                                            url: getDirectionsLink.value,
                                            class: "mt-10 !text-white",
                                            target: "_blank",
                                            text: "Get directions"
                                        }, null, 8, ["url"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_unref(MqResponsive), { group: "" }, {
                                "md-": _withCtx(() => [
                                    _createVNode(_unref(AccordionToggle), { title: "Opening hours" }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("div", null, null, 512), [
                                                [_directive_dompurify_html, formattedOpeningHours.value]
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                "lg+": _withCtx(() => [
                                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs font-bold" }, "Opening hours", -1)),
                                    _withDirectives(_createElementVNode("div", null, null, 512), [
                                        [_directive_dompurify_html, formattedOpeningHours.value]
                                    ]),
                                    (__props.visitPage.url)
                                        ? (_openBlock(), _createBlock(_unref(ButtonWithArrow), {
                                            key: 0,
                                            class: "mt-10 !text-white",
                                            text: "Plan your visit",
                                            url: __props.visitPage.url
                                        }, null, 8, ["url"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            (__props.contactPage.url)
                                ? (_openBlock(), _createBlock(_unref(ButtonWithArrow), {
                                    key: 0,
                                    url: __props.contactPage.url,
                                    class: "!text-white",
                                    text: "Contact us"
                                }, null, 8, ["url"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(OtherSitesNavigation), { navigation: __props.ourOtherSites }, null, 8, ["navigation"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(__props.copyrightInformation), 1),
                            _createVNode(_unref(PoliciesNavigation), { navigation: __props.policiesNavigation }, null, 8, ["navigation"])
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "order-last col-span-full !border-none pb-10 text-[0.75rem] lg:pb-20" }, [
                            _createTextVNode(" Designed by "),
                            _createElementVNode("a", {
                                href: "https://theunloved.co.uk/",
                                rel: "noopener noreferrer",
                                target: "_blank"
                            }, " the unloved. "),
                            _createTextVNode(" Developed by "),
                            _createElementVNode("a", {
                                href: "https://www.effectdigital.com/",
                                rel: "noopener noreferrer",
                                target: "_blank"
                            }, " effect digital. ")
                        ], -1))
                    ])
                ])
            ], 64));
        };
    }
});
